import React from "react";
import { Typography, Link, Breadcrumbs } from "@material-ui/core";

export default function BreadcrumbCommon(props) {

  const capitalize = (str) => {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return "";
  }

  return (
    <>
     {props.card.routing !== 'guide-portal' &&
        <Breadcrumbs
          className="BreadcrumbsDashboard"
          separator="›"
          aria-label="breadcrumb"
        >
          <Typography variant="body2" className="view" color="textPrimary">
            <Link color="inherit" href="/dashboard/">
              Dashboard
            </Link>
          </Typography>
        {props.card.name !== false &&
          <Typography variant="body2" className="view" color="textPrimary">
            <Link color="inherit" href={`/dashboard/${props.card.routing}`}>
              {props.card.name.replace("-", " ")}
            </Link>
          </Typography>
          }
          <Typography variant="body2" className="view" color="textPrimary">
          {capitalize(props?.card?.view)}
          </Typography>
        </Breadcrumbs>
      }
    </>
  );
}
